import { TranslationService } from '../../../services/translation.service';

function ShowMoreButton({ ariaControls, onClick }: { ariaControls: string; onClick: () => void }) {
  return (
    <div>
      <button aria-controls={ariaControls} className="d-block btn--as-link text-center mb-0 mx-auto text-decoration-underline" onClick={onClick}>
        {TranslationService.get('common.showmore')}
      </button>
    </div>
  );
}
export default ShowMoreButton;
